/* eslint-disable indent */
import React from 'react';
import { Link } from 'react-router-dom';

import { setSessionStorageItem } from '../../utils/sessionStorage';
import { Desktop, Mobile } from '../Common/const';
import AudioBadge from './Badges/AudioBadge';
import PDFBadge from './Badges/PDFBadge';
import VisibilityBadge from './Badges/VisibilityBadge';
import StudyCounters from './StudyCounters';

class StudyListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disabledChapter: this.props.disabled,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.disabled !== this.props.disabled) {
      this.setState({ disabledChapter: this.props.disabled });
    }
  }

  getDataType = () => {
    // To know what kind of data we are collecting, we are going to evaluate the location
    if (this.props.location !== undefined) {
      const location = this.props.location;

      switch (true) {
        case location.pathname.includes('quals-and-certs'):
          return '?isChapterId';
        default:
          return '?isChapterId';
      }
    } else {
      return '?isStudyPlanChapter';
    }
  };

  handleOnItemClick = () => {
    if (
      this.props.userSubscription?.warfarePlan &&
      !this.props.location.pathname.includes('quals-and-certs')
    ) {
      this.props.openSwitchToPaid();
      return;
    }
    setSessionStorageItem('nextUpItem', this.props.nextUpItemIndex);
    setSessionStorageItem('nextUpSection', this.props.nextUpSectionIndex);
    setSessionStorageItem('qualIndex', this.props.nextUpQualIndex);

    if (this.props.setQuestionNotification) {
      this.props.setQuestionNotification(this.props.id);
    }
    if (this.props.setChapterId) {
      this.props.setChapterId(this.props.id);
    }
  };

  updateAudioPlaylistProgress = () => {
    this.props.updateAudioPlaylistProgress(this.props.id, -1, 'PENDING', true);
  };

  clickAudioIcon = () => {
    const userIsActive = this.props.userSubscription.status === 'active';
    if (!userIsActive) {
      // Set true to set modal message for audio
      this.props.setSwitchToPaidModalIsForAudio(true);
      this.props.openSwitchToPaid();
    } else {
      const userSubscriptionOffersAudios =
        (this.props.userSubscription.interval === 'Annually' ||
          this.props.userSubscription.interval === 'SemiAnnually') &&
        !this.props.userSubscription.warfarePlan;
      if (userSubscriptionOffersAudios) {
        const chapterId = this.props.id;
        const chapterName = this.props.name;
        this.props.startAudioPlaylist(chapterId, chapterName);
      } else {
        this.props.openUpgradeSubscriptionForAudiosModal();
      }
    }
  };

  changeChapter = () => {
    this.setState(() => ({
      disabledChapter: !this.state.disabledChapter,
    }));
    this.props.updateDisabledChapter(this.props.id, this.props.user.id);
  };

  renderNeedPub() {
    return (
      <a
        href="https://promotionwingman.com/how-to-submit-a-publication/"
        target="_blank"
        className="link-need-publication"
        rel="noreferrer"
      >
        We need this pub! Submit here!
      </a>
    );
  }

  render() {
    const subscription = this.props.userSubscription;
    let fullTitle = '';
    // add the - only when it has description, was need for study weeks
    if (this.props.bookTitle) {
      fullTitle += this.props.bookTitle;
    }
    if (this.props.bookDescription) {
      fullTitle = `${fullTitle} - ${this.props.bookDescription}`;
    }
    if (fullTitle !== '') {
      fullTitle += ', ';
    }
    if (this.props.name) {
      fullTitle += this.props.referenceName
        ? this.props.referenceName
        : this.props.name;
    }
    if (this.props.description) {
      fullTitle = `${fullTitle} - ${this.props.description}`;
    }

    let auxPath = this.getDataType();
    auxPath += `&sp=${this.props.studyProgramId}&id=${this.props.id}`;
    const link = `/app/question/${this.props.studyProgramId}/${this.props.id}`;
    const disabledViewPDF =
      (subscription && subscription.isCancelled && !subscription.status) ||
      (subscription && subscription.status === 'trialing');
    const warfareCondition =
      this.props.userSubscription &&
      this.props.userSubscription.warfarePlan &&
      !this.props.location.pathname.includes('quals-and-certs');
    return (
      <div>
        <li
          className="list-group-item d-flex flex-row align-items-center cursor-pointer py-0"
          key={this.props.id}
        >
          <Desktop>
            <div className="titleAndNeedPub">
              <Link
                onClick={this.handleOnItemClick}
                className={`py-3 w-75 ${
                  this.state.disabledChapter ? 'link-disabled' : ''
                }`}
                to={
                  !(
                    this.props.comingSoon ||
                    (this.props.reviewInFuture == 0 &&
                      this.props.new +
                        this.props.learning +
                        this.props.review <=
                        0) ||
                    this.props.deletedAt ||
                    warfareCondition
                  )
                    ? {
                        pathname: link,
                        studyProgramId: this.props.studyProgramId,
                        id: this.props.id,
                        search: auxPath,
                      }
                    : '#'
                }
              >
                {fullTitle}
              </Link>
              {this.props.weNeedThisPublication && !this.props.bookNeedPub && (
                <div className="needPubChapter">{this.renderNeedPub()}</div>
              )}
            </div>
            <div className="badges-counter-container">
              <div className="study-badges-container d-flex flex-row">
                {(this.props.hasPlaylist || this.props.hasAudioSummary) &&
                  !this.state.disabledChapter && (
                    <AudioBadge
                      progress={this.props.audioProgress}
                      onClick={this.clickAudioIcon}
                      onRestart={this.updateAudioPlaylistProgress}
                      hasAudioSummary={this.props.hasAudioSummary}
                      hasPlaylist={this.props.hasPlaylist}
                    />
                  )}
                {!this.state.disabledChapter && (
                  <PDFBadge
                    isDisabled={disabledViewPDF || warfareCondition}
                    onDisabled={() => this.props.openSwitchToPaid()}
                    isMobile={false}
                    chapterId={this.props.id}
                    PDFUrl={this.props.pdfUrl}
                    getPdfByReference={this.props.getPdfByReference}
                  />
                )}
                <VisibilityBadge
                  isDisabled={this.state.disabledChapter}
                  onDisabled={() => this.changeChapter()}
                  isMobile={false}
                />
              </div>
              <div className="d-flex flex-row align-items-center study-counter-container">
                <StudyCounters
                  comingSoon={
                    this.props.comingSoon ||
                    (this.props.reviewInFuture === 0 &&
                      this.props.new +
                        this.props.learning +
                        this.props.review <=
                        0)
                  }
                  deletedItem={this.props.deletedAt}
                  id={this.props.id}
                  reviewWhen={this.props.reviewWhen}
                  new={this.props.new}
                  learning={this.props.learning}
                  review={this.props.review}
                />
              </div>
            </div>
          </Desktop>
          <Mobile>
            <div className="d-flex flex-column w-100">
              <Link
                onClick={this.handleOnItemClick}
                className="py-3 w-100"
                to={
                  !(
                    this.props.comingSoon ||
                    (this.props.reviewInFuture == 0 &&
                      this.props.new +
                        this.props.learning +
                        this.props.review <=
                        0) ||
                    this.props.deletedAt ||
                    warfareCondition
                  )
                    ? {
                        pathname: link,
                        studyProgramId: this.props.studyProgramId,
                        id: this.props.id,
                        search: auxPath,
                      }
                    : '#'
                }
              >
                {fullTitle}
                <StudyCounters
                  comingSoon={
                    this.props.comingSoon ||
                    (this.props.reviewInFuture == 0 &&
                      this.props.new +
                        this.props.learning +
                        this.props.review <=
                        0)
                  }
                  deletedItem={this.props.deletedAt}
                  id={this.props.id}
                  reviewWhen={this.props.reviewWhen}
                  new={this.props.new}
                  learning={this.props.learning}
                  review={this.props.review}
                />
              </Link>
              {this.props.weNeedThisPublication && !this.props.bookNeedPub && (
                <div className="needPubChapter">{this.renderNeedPub()}</div>
              )}
            </div>
            <div className="d-flex flex-row mobile-icons">
              {(this.props.hasPlaylist || this.props.hasAudioSummary) &&
                !this.state.disabledChapter && (
                  <AudioBadge
                    progress={this.props.audioProgress}
                    onClick={this.clickAudioIcon}
                    onRestart={this.updateAudioPlaylistProgress}
                    hasAudioSummary={this.props.hasAudioSummary}
                    hasPlaylist={this.props.hasPlaylist}
                  />
                )}
              {!this.state.disabledChapter && (
                <PDFBadge
                  isDisabled={disabledViewPDF || warfareCondition}
                  onDisabled={() => this.props.openSwitchToPaid()}
                  isMobile
                  chapterId={this.props.id}
                  PDFUrl={this.props.pdfUrl}
                  getPdfByReference={this.props.getPdfByReference}
                />
              )}
              <VisibilityBadge
                isDisabled={this.state.disabledChapter}
                onDisabled={() => this.changeChapter()}
                isMobile
              />
            </div>
          </Mobile>
        </li>
      </div>
    );
  }
}

export default StudyListItem;
